import React from 'react';
import './WelcomeVideo.scss';

const WelcomeVideo = ({ popUpVideoId, videos }) => {
  const video = videos[popUpVideoId];
  if (!video) return null;

  const iframe = {
    __html: video.src,
  };

  return (
    <div className="welcome-video">
      <div
        className="welcome-video__iframe-wrapper"
        dangerouslySetInnerHTML={iframe}
      />
    </div>
  );
};

export default WelcomeVideo;
